import React,{useEffect,useState} from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomTextArea from '../../../constants/CustomTextArea';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomButton from '../../../constants/CustomButton';
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {setresearchprojectsData,getresearchprojectsData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";


const validationSchema = Yup.object().shape({
    title: Yup.string()
    .required('Required'),
    role: Yup.string()
    .required('Required'),
    status: Yup.string()
    .required('Required'),
    sactioned_date: Yup.string()
    .required('Required'),
 
});
const Researchprojects = (props) => {
    const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getresearchprojectsData();
    },[isLoading])
    const columns = [ 
        {title:'project Title',field:'title'},
        {title:'Role',field:'role' },
        {title:'Duration',field:'duration'},
        {title: "Sactioned Date",field:"sactioned_date"},
        {title:'Collaboration',field:'collaboration'}
      ]
  return (
    <div className="customContainer">
        <CustomHeading title="Research Projects"/>
        <CustomTableWithAll data={props?.research_projects?.data}  columns={columns} api="/api/research_projects/"  title={'All Research Projects'} />
        <CustomLine/>
        <Formik 
                initialValues={{
                    title:'',
                    role:'',
                    team_member:'',
                    status:'',
                    collaboration:'',
                    sactioned_date:'',
                    quantum:'',
                    duration:'',
                    funding_agency:''
                  
                   }}
                   validationSchema={validationSchema}
                   onSubmit={values => {
                    console.log(values);
                    props.setresearchprojectsData(values);
                    setIsLoading(true)
                    
                  }}
            >
            {({ errors, touched,handleChange,handleSubmit }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
                <div className="row">
                    <div className="col-md-4">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Program title '}
                        label={'Program title :'}
                        onChange={handleChange('title')}
                        errorText={
                            errors.title && touched.title ?errors.title :null
                        }
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                            type={'date'}
                            label={'Sactioned date: '}
                            onChange={handleChange('sactioned_date')}
                            errorText={
                                errors.sactioned_date && touched.sactioned_date ?errors.sactioned_date :null
                            }
                            
                        />
                    </div>
                    <div className="col-md-4">
                    <CustomDropdown 
                    label="Role : "
                    data={[{value:"Principal Investigator"},{value:"Co-Investigator"}]}
                    onChange={handleChange('role')}
                    errorText={
                        errors.role && touched.role ?errors.role :null
                    }
                    />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Duration( in months ) '}
                        label={'Duration( in months ):'}
                        onChange={handleChange('duration')}
                        errorText={
                            errors.duration && touched.duration ?errors.duration :null
                        }
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Quantum of Amount Sanctioned'}
                        label={'Quantum of Amount Sanctioned (in Rs. ):'}
                        onChange={handleChange('quantum')}
                        errorText={
                            errors.quantum && touched.quantum ?errors.quantum :null
                        }
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <CustomDropdown 
                    label="Status : "
                    data={[{value:"Ongoing"},{value:"Completed"},{value:"Submitted"}]}
                    onChange={handleChange('status')}
                    errorText={
                        errors.status && touched.status ?errors.status :null
                    }
                    />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                    <CustomTextArea
                            type={'text'}
                            label={'Collaboration : '}
                            placeholder={'Enter Collaboration'}
                            onChange={handleChange('collaboration')}
                        />
                    </div>
                    <div className="col-md-4">
                    <CustomTextArea
                            type={'text'}
                            label={'funding_agency : '}
                            placeholder={'Enter Funding Agency'}
                            onChange={handleChange('funding_agency')}
                        />
                    </div>
                    <div className="col-md-4">
                    <CustomTextArea
                            type={'text'}
                            label={'Team member(s) : '}
                            placeholder={'Enter Team member(s)'}
                            onChange={handleChange('team_member')}
                        />
                    </div>
                </div>
                <CustomButton type="submit" label="Save" isIcon/>
             </Form>
              )}
            </Formik>
    </div>
  );
};
const mapActionWithProps = {
    getresearchprojectsData,
    setresearchprojectsData,
  }
  
  const mapStateWithProps = (state)=>(
    {
        research_projects:state.data.research_projects
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(Researchprojects);
